export default __webpack_public_path__ + "static/media/1.1d6b0361.png";